import Alpine from 'alpinejs';

function defaultField() {
    return { name: '', label: '', placeholder: '', required: true, max: 120, extra: false };
}

function defaultLayer() {
    return {
        id: 'layer_' + Date.now(),
        bind: '',
        label: 'Layer Baru',
        font: 'Arial Black',
        size_cqw: 3,
        color: '#FFFFFF',
        x: 50,
        y: 50,
        width: null,
        uppercase: false,
        nowrap: true,
        anchor: 'center',
        weight: 700,
        shadow: '',
        stroke: '',
    };
}

function createFlowerTemplateBuilder(initial = {}, fonts = []) {
    const state = {
        locked: true,
        draggable: true,
        aspect_ratio: '588/423',
        bg_fit: 'cover',
        fields: [],
        layers: [],
        ...initial,
    };

    return {
        builder: state,
        fonts,
        showJson: false,
        configJson: '',

        init() {
            if (!this.builder.fields?.length) {
                this.builder.fields = [defaultField()];
            }
            if (!this.builder.layers?.length) {
                this.builder.layers = [defaultLayer()];
            }
            this.syncJson();
            this.$watch('builder', () => this.syncJson(), { deep: true });
        },

        syncJson() {
            this.configJson = JSON.stringify(this.buildConfig(), null, 2);
        },

        buildConfig() {
            return {
                locked: !!this.builder.locked,
                draggable: !!this.builder.draggable,
                aspect_ratio: this.builder.aspect_ratio || '588/423',
                bg_fit: this.builder.bg_fit || 'cover',
                bg_masks: [],
                fields: this.builder.fields.filter(f => f.name).map(f => ({
                    name: f.name,
                    label: f.label || f.name,
                    placeholder: f.placeholder || '',
                    required: !!f.required,
                    max: Number(f.max) || 120,
                    ...(f.extra ? { extra: true } : {}),
                })),
                layers: this.builder.layers.filter(l => l.id).map(l => ({
                    id: l.id,
                    type: 'text',
                    bind: l.bind || l.id,
                    x: Number(l.x) || 50,
                    y: Number(l.y) || 50,
                    anchor: l.anchor || 'center',
                    z: 8,
                    font: l.font || 'Arial',
                    size_cqw: Number(l.size_cqw) || 3,
                    color: l.color || '#FFFFFF',
                    weight: Number(l.weight) || 700,
                    ...(l.width ? { width: Number(l.width) } : {}),
                    ...(l.uppercase ? { uppercase: true } : {}),
                    ...(l.nowrap ? { nowrap: true } : {}),
                    ...(l.shadow ? { shadow: l.shadow } : {}),
                    ...(l.stroke ? { stroke: l.stroke } : {}),
                })),
            };
        },

        previewValues() {
            const values = {};
            (this.builder.fields || []).forEach((f) => {
                if (!f.name) return;
                values[f.name] = f.placeholder || f.label || f.name.toUpperCase();
            });
            return values;
        },

        previewPositions() {
            const positions = {};
            (this.builder.layers || []).forEach((l) => {
                if (!l.id) return;
                positions[l.id] = { x: Number(l.x) || 50, y: Number(l.y) || 50 };
            });
            return positions;
        },

        addField() {
            this.builder.fields.push(defaultField());
        },

        removeField(index) {
            this.builder.fields.splice(index, 1);
        },

        addLayer() {
            const layer = defaultLayer();
            layer.bind = layer.id;
            this.builder.layers.push(layer);
        },

        removeLayer(index) {
            this.builder.layers.splice(index, 1);
        },

        applyPreset(preset) {
            if (preset === 'wedding') {
                Object.assign(this.builder, {
                    locked: true,
                    draggable: true,
                    aspect_ratio: '588/423',
                    fields: [
                        { name: 'headline', label: 'Judul Ucapan', placeholder: 'Happy Wedding', required: true, max: 60, extra: false },
                        { name: 'groom', label: 'Nama Pengantin Pria', placeholder: 'Rama', required: true, max: 80, extra: true },
                        { name: 'bride', label: 'Nama Pengantin Wanita', placeholder: 'Febi', required: true, max: 80, extra: true },
                        { name: 'sender_name', label: 'Nama Pengirim', placeholder: 'PT INDAH PADANG', required: true, max: 150, extra: false },
                        { name: 'sender_title', label: 'Jabatan Pengirim', placeholder: 'PADANG', required: true, max: 120, extra: true },
                    ],
                    layers: [
                        { id: 'headline', bind: 'headline', label: 'Headline', font: 'Great Vibes', size_cqw: 7.5, color: '#FFE566', x: 50, y: 28, width: null, uppercase: false, nowrap: true, anchor: 'center', weight: 700, shadow: '2px 2px 0 #B91C1C', stroke: '1px #DC2626' },
                        { id: 'groom', bind: 'groom', label: 'Pengantin Pria', font: 'Arial Black', size_cqw: 3.8, color: '#FFFFFF', x: 40, y: 44, width: 18, uppercase: true, nowrap: true, anchor: 'center', weight: 900, shadow: '1px 2px 4px rgba(0,0,0,.45)', stroke: '' },
                        { id: 'bride', bind: 'bride', label: 'Pengantin Wanita', font: 'Arial Black', size_cqw: 3.8, color: '#FFFFFF', x: 60, y: 44, width: 18, uppercase: true, nowrap: true, anchor: 'center', weight: 900, shadow: '1px 2px 4px rgba(0,0,0,.45)', stroke: '' },
                        { id: 'sender_name', bind: 'sender_name', label: 'Nama Pengirim', font: 'Arial Black', size_cqw: 2.4, color: '#FFFFFF', x: 50, y: 58, width: 88, uppercase: true, nowrap: false, anchor: 'center', weight: 900, shadow: '1px 1px 3px rgba(0,0,0,.5)', stroke: '' },
                        { id: 'sender_title', bind: 'sender_title', label: 'Jabatan', font: 'Arial Black', size_cqw: 2.1, color: '#FFFFFF', x: 50, y: 63, width: 86, uppercase: true, nowrap: true, anchor: 'center', weight: 800, shadow: '1px 1px 3px rgba(0,0,0,.5)', stroke: '' },
                    ],
                });
            }
        },

        beforeSubmit(event) {
            const form = event.target;
            let input = form.querySelector('input[name="config_json"]');
            if (!input) {
                input = document.createElement('input');
                input.type = 'hidden';
                input.name = 'config_json';
                form.appendChild(input);
            }
            input.value = this.configJson;
        },
    };
}

Alpine.data('flowerTemplateBuilder', (initial, fonts) => createFlowerTemplateBuilder(initial, fonts));

export { createFlowerTemplateBuilder };
